import React, { ComponentType, useState } from 'react';

import { RemountOnKey } from '@/shared/components/RemountOnKey/RemountOnKey';

import { usePlayingContentIdChangeHandler } from '../hooks/use-playing-content-id-change-handler';

export const withPlayingContentChangeRemount = <P extends object>(Component: ComponentType<P>) => {
    const WithPlayingContentChangeRemount: ComponentType<P> = (props: P) => {
        const [key, setKey] = useState(0);

        usePlayingContentIdChangeHandler({ onChange: () => setKey((prev) => prev + 1) });

        return (
            <RemountOnKey mountKey={key}>
                <Component {...props} />
            </RemountOnKey>
        );
    };

    WithPlayingContentChangeRemount.displayName = `withPlayingContentChangeRemount(${
        Component.displayName || Component.name || 'Component'
    })`;

    return WithPlayingContentChangeRemount;
};
